/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailboxAddressConfigDTO
 */
export interface MailboxAddressConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    Id?: string;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    LocalPart: string;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    CustomDomain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    FullAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    RootDomain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    MailFooter?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxAddressConfigDTO
     */
    SenderName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MailboxAddressConfigDTO
     */
    Enabled?: boolean;
}

/**
 * Check if a given object implements the MailboxAddressConfigDTO interface.
 */
export function instanceOfMailboxAddressConfigDTO(value: object): value is MailboxAddressConfigDTO {
    if (!('LocalPart' in value) || value['LocalPart'] === undefined) return false;
    return true;
}

export function MailboxAddressConfigDTOFromJSON(json: any): MailboxAddressConfigDTO {
    return MailboxAddressConfigDTOFromJSONTyped(json, false);
}

export function MailboxAddressConfigDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxAddressConfigDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'] == null ? undefined : json['Id'],
        'LocalPart': json['LocalPart'],
        'CustomDomain': json['CustomDomain'] == null ? undefined : json['CustomDomain'],
        'FullAddress': json['FullAddress'] == null ? undefined : json['FullAddress'],
        'RootDomain': json['RootDomain'] == null ? undefined : json['RootDomain'],
        'MailFooter': json['MailFooter'] == null ? undefined : json['MailFooter'],
        'SenderName': json['SenderName'] == null ? undefined : json['SenderName'],
        'Enabled': json['Enabled'] == null ? undefined : json['Enabled'],
    };
}

export function MailboxAddressConfigDTOToJSON(json: any): MailboxAddressConfigDTO {
    return MailboxAddressConfigDTOToJSONTyped(json, false);
}

export function MailboxAddressConfigDTOToJSONTyped(value?: MailboxAddressConfigDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'LocalPart': value['LocalPart'],
        'CustomDomain': value['CustomDomain'],
        'FullAddress': value['FullAddress'],
        'RootDomain': value['RootDomain'],
        'MailFooter': value['MailFooter'],
        'SenderName': value['SenderName'],
        'Enabled': value['Enabled'],
    };
}

